import type { MoveAttachmentToSiteFilesAttachment } from 'src/graphql/entities/files-upload.types';

export const CONVERSATION_ATTACHMENT_DRAG_DATA_TYPE =
  'application/x-provision-conversation-attachment';

const isString = (value: unknown): value is string => typeof value === 'string';

const hasConversationAttachmentDragPayloadShape = (
  value: unknown,
): value is MoveAttachmentToSiteFilesAttachment => {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const payload = value as Partial<MoveAttachmentToSiteFilesAttachment>;

  return (
    isString(payload.id) &&
    typeof payload.partnerId === 'number' &&
    isString(payload.fileKey) &&
    isString(payload.fileName) &&
    (payload.contentType === null ||
      payload.contentType === undefined ||
      isString(payload.contentType)) &&
    (payload.size === null || payload.size === undefined || typeof payload.size === 'number')
  );
};

export const setConversationAttachmentDragData = (
  dataTransfer: DataTransfer,
  attachment: MoveAttachmentToSiteFilesAttachment,
): void => {
  dataTransfer.effectAllowed = 'copy';
  dataTransfer.setData(CONVERSATION_ATTACHMENT_DRAG_DATA_TYPE, JSON.stringify(attachment));
  dataTransfer.setData('text/plain', attachment.fileName);
};

export const getConversationAttachmentDragData = (
  dataTransfer: DataTransfer,
): MoveAttachmentToSiteFilesAttachment | null => {
  const rawPayload = dataTransfer.getData(CONVERSATION_ATTACHMENT_DRAG_DATA_TYPE);

  if (!rawPayload) {
    return null;
  }

  try {
    const payload: unknown = JSON.parse(rawPayload);

    if (!hasConversationAttachmentDragPayloadShape(payload)) {
      return null;
    }

    return payload;
  } catch {
    return null;
  }
};
